import { Button, Checkbox, Form } from 'antd';
import React, { FC, useState } from 'react';

import { openNotification } from '../../../common/helpers';
import { NotificationTypes } from '../../../common/interfaces';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { userApi } from '../../../store/api/user.api';
import { Question, UpdateTestDto } from './Test.interfaces';
import styles from './Test.module.scss';

type Props = {
  name?: string;
};

interface SubmitTestFormValues {
  [key: string]: number[];
}

export const Test: FC<Props> = () => {
  const { tests } = useTypedSelector((state) => state.registration);

  // отправка ответов на тест
  const [updateTest, { isLoading: isTestUpdateLoading }] =
    userApi.useTestUpdateMutation();

  const [form] = Form.useForm();

  const onSubmit = async (values: SubmitTestFormValues) => {
    console.log('777------Test values', values);
    const updateTestRequest: UpdateTestDto = Object.entries(values).map(
      ([key, value]): Question => {
        return {
          questionId: key,
          answer: value,
        };
      },
    );

    try {
      const result = await updateTest(updateTestRequest);
      if (result.data?.result) {
        openNotification(NotificationTypes.SUCCESS, 'Тест успешно пройден!');
      } else {
        const message = `Вы не прошли тест, попробуйте еще раз. 
        Правильных ответов: ${result.data?.correctAnswersQty} из ${result.data?.answersQty}`;
        openNotification(NotificationTypes.ERROR, message);
        form.resetFields();
      }
    } catch (e) {
      console.error(e);
      openNotification(
        NotificationTypes.ERROR,
        'Ошибка отправки результатов тестов',
      );
    }
  };

  return (
    <div>
      <Form form={form} onFinish={onSubmit}>
        <title className={styles.title}>
          ТЕСТ на определение знаний (компетентности) для совершения сделок с
          виртуальными активами QUESTIONNAIRE to test your readiness to deal
          with virtual assets
        </title>

        {tests.map((test, index) => (
          <Form.Item
            key={test.id}
            style={{ display: 'flex', flexDirection: 'column' }}
            name={test.id}
          >
            <Checkbox.Group>
              <label className={styles['question-title']}>
                {index + 1}. {test.description}
              </label>
              {test.items.map((item) => (
                <Checkbox value={item.number} key={item.number}>
                  {item.variant}
                </Checkbox>
              ))}
            </Checkbox.Group>
          </Form.Item>
        ))}
      </Form>

      <Button
        onClick={() => form.submit()}
        type="primary"
        loading={isTestUpdateLoading}
      >
        Отправить тест
      </Button>
    </div>
  );
};
